import { useIntl } from 'react-intl';

import { TMake } from '@src-common/api/definitions/w4d-cars-types';

import { Wheelbase, WHEELBASES_MESSAGES } from '../api/hardcoded-make-models';

import { useModelConfig } from './useModelConfig';

const useWheelbases = (make?: TMake, model?: string) => {
  const intl = useIntl();
  const modelConfig = useModelConfig(make, model);

  if (!modelConfig || !model) {
    return [];
  }

  return modelConfig.wheelbases.map(wheelbaseOption => ({
    title: intl.formatMessage(WHEELBASES_MESSAGES[wheelbaseOption as Wheelbase]),
    value: wheelbaseOption,
  }));
};

export { useWheelbases };
